export const envConfig = {
  BASE_URL: "https://app-sandbox.rewardmenow.co.uk/api/v6",
};
